import { ProfileSectionType } from "../../../types";
import { getUserDetailsCache } from "../../../utils/authHelpers";

const ProfileHeader = ({
  section = "profile",
  handleTopNavBtn,
}: {
  section: ProfileSectionType;
  handleTopNavBtn: () => void;
}) => {
  const pageTitle = {
    profile: "Profile Overview",
    settings: "Settings",
    subscription: "Subscription Plan",
    edit: "Edit Profile",
    "password-change": "Change Password",
    help: "Help & Support",
  };

  const userDetailsCache = getUserDetailsCache();

  return (
    <div className="w-full text-gray-7">
      <div className="w-full h-full flex flex-col items-center mx-auto pb-10 max-w-[calc(100%-64px)] xl:max-w-[920px] border-b border-gray-2">
        <h1 className="font-semibold text-2xl mb-6">{pageTitle[section]}</h1>
        {userDetailsCache?.name && (
          <h2 className="font-semibold text-[32px] mb-1">
            {userDetailsCache.name}
          </h2>
        )}
        {userDetailsCache?.email && (
          <p className="font-normal text-xl text-gray-6 mb-4">
            {userDetailsCache.email}
          </p>
        )}
        <button
          onClick={handleTopNavBtn}
          className="rounded-[10px] bg-black py-2 px-[43.5px] text-white"
        >
          {section === "profile" ? "Back to Home" : "Back to Profile"}
        </button>
      </div>
    </div>
  );
};

export default ProfileHeader;
